import Api from "./api";

class WordstatApi {
    api = new Api();

    /**
     * Создание нового проекта задания на парсинг фраз/частотности
     * @param data{{
     *     name: ?String,
     *     regionId: Number,
     *     words: String[],
     *     type: Number,
     *     source?: Number,
     * }}
     * @return {Promise<{
     *     id: Number,
     * }>}
     */
    createProject(data) {
        return this.api.post('wordstat/create-project', {data: data});
    }

    /**
     * Обновление данных проекта
     * @param {Number} projectId
     * @param payload {{
     *     ws_types: Number[],
     * }}
     * @returns {Promise<[]>}
     */
    updateProject(projectId, payload) {
        return this.api.post(sprintf('wordstat/%d/update-project', projectId), payload);
    }

    /**
     * Удаление проекта
     */
    deleteProject(data = {projectId: null}) {
        return this.api.delete('wordstat/delete-project', {data: data});
    }

    /**
     * Переименование проекта
     */
    updateProjectName(data = {projectId: null, projectName: null}) {
        return this.api.post('wordstat/update-project-name', {data: data});
    }

    /**
     * Получаем данные готовых проектов
     * @param {String} projectsIds - список ID проектов через запятую
     * @return {Promise<{
     *     id: Number,
     *     base: Number,
     *     name: String,
     *     batches: Number,
     *     batchesTotal: Number,
     *     created_at: String
     *     updated_at: String,
     *     words_count: Number,
     *     swsk_sum: Number,
     *     cluster_uid: String,
     *     cluster_name: String,
     *     monitoring_id: Number,
     *     monitoring_name: String,
     * }[] | []>}
     */
    getProjectsCompleted(projectsIds) {
        return this.api.get('wordstat/get-projects-completed', {ids: projectsIds});
    }

    /**
     * Проверка статуса завершения обновления
     * @param {Number} projectId
     * @return {Promise<{
     *     batches: Number,
     *     batches_total: Number,
     * }>}
     */
    getProjectStatus(projectId) {
        return this.api.get('wordstat/get-project-status', {id: projectId});
    }

    /**
     * Получаем список проектов
     * @param data{{
     *     sort: String,
     *     page: Number,
     *     per_page: Number,
     *     isMain?: Boolean,
     * }}
     * @return {Promise<{
     *     id: Number,
     *     base: Number,
     *     name: String,
     *     batches: Number,
     *     batches_total: Number,
     *     created_at: String
     *     updated_at: String,
     *     words_count: Number,
     *     swsk_sum: Number,
     *     cluster_uid: String,
     *     cluster_name: String,
     *     monitoring_id: Number,
     *     monitoring_name: String,
     *     source: Number,
     * }[] | []>}
     */
    getProjectsList(data) {
        return this.api.get('wordstat/list', data);
    }

    /**
     * Добавление/обновление слов
     * @param {Number} projectId
     * @param data{{
     *     words: String[],
     *     ws_types: Number[],
     *     type: Number,
     * }}
     * @returns {Promise<[]>}
     */
    updateWords(projectId, data) {
        return this.api.post(sprintf('wordstat/%d/update-words', projectId), {data: data});
    }

    /**
     * Удаление слов
     */
    deleteWords(data = {projectId: null, words: []}) {
        return this.api.delete('wordstat/delete-words', {data: data});
    }

    /**
     * Удаление минус слов
     */
    deleteMinusWords(data = {projectId: null, words: []}) {
        return this.api.delete('wordstat/delete-minus-words', {data: data});
    }
}

export default new WordstatApi;
